import { render } from "./HeroiconsSolidViewBoards.vue?vue&type=template&id=6336c012"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidViewBoards.vue"]])

export default __exports__